/* Notes created from reviews in Doclink are marked hidden. We pass this parameter to some
observation endpoints to specify if we want to accept these ones too. In most cases, this
is false. When opening a linked note through a PNCounterIcon, it should be true. */
export const showHiddenOrdersAndNotes = 'false';